export const blockedSendersCopy = {
  title: '',
  description: '',
  addLabel: '',
  addButton: '',
  searchPlaceholder: '',
  isNew: '',
  isDeleted: '',
  maxListCountMessage: '',
  emailDomainHint: '',
  maxListCountHint: '',
  emptySenderList: '',
};
